// src/components/ui/calendar/core/CalendarHourLabel/CalendarHourLabelShadcn.jsx
import React from 'react';
import { cn } from '../../../../../utils/cn';

const CalendarHourLabelShadcn = ({
  hour,
  format = '12', // '12' or '24'
  className = '',
  size = 'default', // 'sm', 'default', 'lg'
  position = 'right' // 'left', 'center', 'right'
}) => {
  // Size configurations
  const sizeConfig = {
    sm: {
      container: 'w-10 p-1',
      text: 'text-xs'
    },
    default: {
      container: 'w-14 p-2',
      text: 'text-xs'
    },
    lg: {
      container: 'w-16 p-3',
      text: 'text-sm'
    }
  };

  // Position configurations
  const positionConfig = {
    left: 'text-left',
    center: 'text-center',
    right: 'text-right'
  };

  const currentSize = sizeConfig[size];
  const currentPosition = positionConfig[position];

  // Format hour to display string
  const formatHour = (hour) => {
    if (format === '24') {
      return `${hour.toString().padStart(2, '0')}:00`;
    }

    // 12-hour format (matching your current implementation exactly)
    return new Date(2000, 0, 1, hour).toLocaleTimeString('en-US', {
      hour: 'numeric',
      hour12: true
    });
  };

  return (
    <div className={cn(
      // Exact styling from your current implementation
      "border-r border-slate-600/30 bg-slate-800/20 flex-shrink-0",
      currentSize.container,
      className
    )}>
      <div className={cn(
        "font-medium text-slate-400",
        currentSize.text,
        currentPosition
      )}>
        {formatHour(hour)}
      </div>
    </div>
  );
};

export default CalendarHourLabelShadcn;